/**
 * JQuery
 */
import 'script!uglify!jquery';
// ui
import 'script!./../bower_components/jquery-ui/jquery-ui.min';
import './../bower_components/jquery-ui/themes/base/jquery-ui.css';
// migrate
import 'script!uglify!./../node_modules/jquery-migrate/dist/jquery-migrate';
// table sorter
import 'script!uglify!tablesorter';
// drag table
import 'script!uglify!./../bower_components/dragtable/jquery.dragtable';
// checkboxes
import 'script!uglify!./../client-side/Checkboxes/jquery.checkboxes';
// spin
import 'script!uglify!spin.js';
import 'script!uglify!./../node_modules/spin.js/jquery.spin';
// chosen
import 'script!uglify!./../client-side/Chosen/chosen.jquery';
import './../client-side/Chosen/bootstrap-chosen.css';
// table head fixer
import 'script!uglify!./../client-side/TableHeadFixer/TableHeadFixer';

/**
 * Moment.js
 */
import 'script!uglify!./../node_modules/moment/min/moment-with-locales.min';

/**
 * Bootstrap
 */
import 'script!uglify!./../node_modules/bootstrap/dist/js/bootstrap';
// file input
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/fileinput';
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/locales/cz';
import 'script!uglify!./../node_modules/bootstrap-fileinput/js/locales/sk';
import './../node_modules/bootstrap-fileinput/css/fileinput.css';
// eonasdan bootstrap datetimepicker
import 'script!uglify!eonasdan-bootstrap-datetimepicker';
import './../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';
// daterangepicker
import 'script!uglify!bootstrap-daterangepicker';
import './../node_modules/bootstrap-daterangepicker/daterangepicker.css';

/**
 * Nette
 */
import 'script!uglify!./../bower_components/nette-forms/src/assets/netteForms';
import 'script!uglify!./../bower_components/nette.ajax.js/nette.ajax';

/**
 * Tree
 */
import 'script!uglify!./../client-side/Tree/js/tree_javascript';
import './../client-side/Tree/css/tree_css.css';

/**
 * FFS
 */
import FSRibbon from './Ribbon/js/ribbon';
import FSForms from './Form/js/fsForms';
import FSGrid from './Grid/js/grid';
import FSGridSnippet from './GridSnippet/js/grid';

/**
 * LESS
 */
import './../client-side/common/less/main.less';
import './../client-side/common/less/responsive.less';

import 'script!uglify!./../client-side/common/js/responsive';

/**
 * Form live validation
 */
import 'script!uglify!./../client-side/Form/js/formValidation';

/**
 * Metadata Logic
 */
import MetadataLogicConfigurator from './MetadataLogic/MetadataLogicConfigurator';

$(function()
{
  // initialization components
  $.nette.init();
  FSForms.init();
  FSGrid.init();
  FSGridSnippet.initAll();
  FSRibbon.init();
  MetadataLogicConfigurator.createDocumentControlsInit();
  MetadataLogicConfigurator.singleEditDocumentControlsInit();
  MetadataLogicConfigurator.bulkEditDocumentsControlsInit();

  // check fot duplicite init
  if (window.FSForms){
      console.log('%c FormFlow ERROR! Duplicite loading of JS, probably by AJAX!', 'background: red; color: white');
  }

  // set global properties
  window.FSForms = FSForms;
  window.FSGrid = FSGrid;
  window.FSGridSnippet = FSGridSnippet;

  $(document).ajaxComplete(() => {
    MetadataLogicConfigurator.createDocumentControlsInit();
    MetadataLogicConfigurator.singleEditDocumentControlsInit();
    MetadataLogicConfigurator.bulkEditDocumentsControlsInit();
  });
});




// WEBPACK FOOTER //
// ./client-side/bootstrap.js